import VariablesContent from './VariablesContent';
import { VariablesContentProps, VariablesContentValueProps } from './types';

export type { VariablesContentProps, VariablesContentValueProps };
export default VariablesContent;
